import { useCallback, useEffect, useRef } from 'react';
import PageLoader from 'ui/components/PageLoader';
import userManager from '../../app/userManager';
import { clearAppLocalforageData } from '@/app/clearAppLocalforageData';

const Signout = () => {
  const hasHandledSignout = useRef(false);
  const hasStartedSignin = useRef(false);
  const isLoggedOutView = new URLSearchParams(window.location.search).get(
    'status',
  ) === 'logged-out';

  const successCallback = useCallback(async () => {
    const appWindow = window as typeof window & { isOrganization?: unknown };

    localStorage.removeItem('redirectUri');

    try {
      await clearAppLocalforageData();
    } catch (error) {
      console.error('Error clearing local app data during logout:', error);
    }

    delete appWindow.isOrganization;
    window.location.assign('/signout?status=logged-out');
  }, []);

  useEffect(() => {
    if (isLoggedOutView) {
      if (hasStartedSignin.current) {
        return;
      }

      hasStartedSignin.current = true;
      userManager
        .signinRedirect({
          prompt: 'login',
        })
        .catch((error) => {
          console.error('Error redirecting to login after logout:', error);
        });
      return;
    }

    if (hasHandledSignout.current) {
      return;
    }

    hasHandledSignout.current = true;

    const handleSignout = async () => {
      try {
        await userManager.signoutRedirectCallback();
        await successCallback();
      } catch (callbackError) {
        console.error(
          'Error in signout callback, trying signout redirect:',
          callbackError,
        );

        try {
          await userManager.signoutRedirect();
        } catch (redirectError) {
          console.error(
            'Error in signout redirect, running local fallback cleanup:',
            redirectError,
          );
          await successCallback();
        }
      }
    };

    void handleSignout();
  }, [isLoggedOutView, successCallback]);

  return (
    <PageLoader
      title={isLoggedOutView ? 'Skickar dig till inloggning...' : 'Loggar ut...'}
    />
  );
};

export default Signout;
